window.flow = window.flow || {};

Object.assign(window.flow, {
  isProductPage: function() {
    return document.body && document.body.className.indexOf('template-product') !== -1;
  },
  getProductFormV2StickyElements: function() {
    return {
      form: document.querySelector('.template-product-v2 .product-form-v2'),
      gallery: document.querySelector('.template-product-v2 [id^="MediaGallery-"], .template-product-v2 .product-image-container, .template-product-v2 .product-images'),
      footer: document.querySelector('#footer, .footer, .shopify-section-group-footer-group')
    };
  },
  isProductFormV2Mobile: function() {
    return window.matchMedia('(max-width: 767px)').matches;
  },
  setProductFormV2StickyState: function(form, isVisible) {
    if (!form) {
      return;
    }

    form.style.transform = isVisible ? '' : 'translateY(calc(100% + 40px))';
    form.style.pointerEvents = isVisible ? '' : 'none';
    form.style.willChange = 'transform';
    form.dataset.flowStickyVisible = isVisible ? 'true' : 'false';

    if (!isVisible) {
      this.collapseProductFormV2Variants(form);
    }
  },
  setProductFormV2VariantsState: function(form, isExpanded) {
    var variants = form && form.querySelector('variant-selects');
    var variations = variants && variants.querySelector('.variations');
    var selectSizeButton = form && form.querySelector('.product-form-v2-select-size-button');
    var productForm = form && form.querySelector('.product-form');
    var productUpsells = form && form.querySelector('#product-upsells');

    if (!form) {
      return;
    }

    if (variants) {
      variants.style.gridTemplateRows = isExpanded ? '1fr' : '';
      variants.style.opacity = isExpanded ? '1' : '';
      variants.style.overflow = isExpanded ? 'hidden' : '';
    }

    if (variations) {
      variations.style.margin = isExpanded ? '0 0 20px' : '';
    }

    if (selectSizeButton) {
      selectSizeButton.hidden = !this.isProductFormV2Mobile() || isExpanded || !variants;
      selectSizeButton.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    }

    if (productForm) {
      productForm.hidden = !isExpanded && !!variants && this.isProductFormV2Mobile();
    }

    if (productUpsells) {
      productUpsells.hidden = !isExpanded && !!variants && this.isProductFormV2Mobile();
    }

    form.dataset.flowStickyExpanded = isExpanded ? 'true' : 'false';
  },
  expandProductFormV2Variants: function(form) {
    this.setProductFormV2VariantsState(form, true);
  },
  collapseProductFormV2Variants: function(form) {
    this.setProductFormV2VariantsState(form, false);
  },
  updateProductFormV2Sticky: function() {
    var elements = this.getProductFormV2StickyElements();
    var form = elements.form;
    var gallery = elements.gallery;
    var footer = elements.footer;
    var isMobile = this.isProductFormV2Mobile();
    var galleryRect;
    var footerRect;
    var hasPassedGallery;
    var hasReachedFooter;

    if (!form) {
      return;
    }

    if (!isMobile) {
      form.style.transform = '';
      form.style.pointerEvents = '';
      form.style.willChange = '';
      delete form.dataset.flowStickyVisible;
      this.collapseProductFormV2Variants(form);
      return;
    }

    if (!gallery) {
      this.setProductFormV2StickyState(form, true);
      return;
    }

    galleryRect = gallery.getBoundingClientRect();
    footerRect = footer && footer.getBoundingClientRect();
    hasPassedGallery = galleryRect.bottom <= window.innerHeight;
    hasReachedFooter = footerRect && footerRect.top <= window.innerHeight;

    this.setProductFormV2StickyState(form, hasPassedGallery && !hasReachedFooter);
  },
  initProductFormV2Sticky: function() {
    var ticking = false;
    var elements;
    var form;

    if (!this.isProductPage()) {
      return;
    }

    elements = this.getProductFormV2StickyElements();
    form = elements.form;

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function() {
        ticking = false;
        flow.updateProductFormV2Sticky();
      });
    }

    flow.updateProductFormV2Sticky();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', requestUpdate);

    if (!form) {
      return;
    }

    this.collapseProductFormV2Variants(form);

    form.addEventListener('click', function(event) {
      var selectSizeButton = event.target.closest('.product-form-v2-select-size-button');

      if (!selectSizeButton || !form.contains(selectSizeButton)) {
        return;
      }

      flow.expandProductFormV2Variants(form);
    });

    document.addEventListener('click', function(event) {
      if (!flow.isProductFormV2Mobile() || form.dataset.flowStickyExpanded !== 'true') {
        return;
      }

      if (form.contains(event.target)) {
        return;
      }

      flow.collapseProductFormV2Variants(form);
    });
  },
  getYotpoMainWidget: function() {
    var selectors = [
      '.yotpo-main-widget',
      '.yotpo-reviews-main-widget',
      // '.yotpo-widget-main-widget',
      // '.yotpo-display-wrapper',
      // '.yotpo-widget-instance:not([data-yotpo-instance-id="1317447"])'
    ];

    return document.querySelector(selectors.join(','));
  },
  isElementVisible: function(element) {
    var rect;
    var style;

    if (!element) {
      return false;
    }

    style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  },
  isYotpoMainWidgetVisible: function() {
    return this.isElementVisible(this.getYotpoMainWidget());
  },
  flattenYotpoReviewPanels: function(root) {
    var scope = root || document;
    var reviews = [];
    var panelSelectors = [
      '.yotpo-review-left-panel',
      '.yotpo-review-center-panel',
      '.yotpo-review-right-panel'
    ];

    if (scope.nodeType === 1 && scope.matches('.yotpo-review')) {
      reviews.push(scope);
    }

    reviews = reviews.concat(Array.prototype.slice.call(scope.querySelectorAll('.yotpo-review')));

    reviews.forEach(function(review) {
      panelSelectors.forEach(function(selector) {
        var panel = review.querySelector(selector);

        if (!panel || panel.parentElement !== review) {
          return;
        }

        while (panel.firstChild) {
          review.insertBefore(panel.firstChild, panel);
        }

        panel.remove();
      });

      var ratingTitle = review.querySelector('.yotpo-review-rating-title');
      var reviewTitle = ratingTitle && ratingTitle.querySelector('.yotpo-review-title');

      if (ratingTitle && reviewTitle) {
        ratingTitle.insertAdjacentElement('afterend', reviewTitle);
      }
    });
  },
  observeYotpoReviews: function(root) {
    var target = root || this.getYotpoMainWidget() || document.body;
    var observer;

    this.flattenYotpoReviewPanels(target);

    observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes, function(node) {
            if (node.nodeType === 1) {
              flow.flattenYotpoReviewPanels(node);
            }
          });
        }
      });

      flow.flattenYotpoReviewPanels(target);
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });

    return observer;
  },
  detectYotpoMainWidget: function(options) {
    var settings = options || {};
    var timeout = settings.timeout || 10000;
    var visibleClass = settings.visibleClass || 'flow-yotpo-main-widget-visible';
    var onVisible = settings.onVisible;
    var startedAt = Date.now();
    var observer;
    var interval;

    if (!this.isProductPage()) {
      return;
    }

    function markVisible(widget) {
      document.body.classList.add(visibleClass);
      document.body.setAttribute('data-yotpo-main-widget-visible', 'true');
      flow.observeYotpoReviews(widget);

      document.dispatchEvent(new CustomEvent('flow:yotpo-main-widget:visible', {
        detail: {
          widget: widget
        }
      }));

      if (typeof onVisible === 'function') {
        onVisible(widget);
      }
    }

    function stopWatching() {
      if (observer) {
        observer.disconnect();
      }

      if (interval) {
        window.clearInterval(interval);
      }
    }

    function checkWidget() {
      var widget = flow.getYotpoMainWidget();

      if (flow.isElementVisible(widget)) {
        stopWatching();
        markVisible(widget);
        return true;
      }

      if (Date.now() - startedAt >= timeout) {
        stopWatching();
      }

      return false;
    }

    if (checkWidget()) {
      return;
    }

    observer = new MutationObserver(checkWidget);
    observer.observe(document.body, {
      attributes: true,
      childList: true,
      subtree: true
    });

    interval = window.setInterval(checkWidget, 250);
  }
});

document.addEventListener('DOMContentLoaded', function() {
  flow.initProductFormV2Sticky();
  flow.detectYotpoMainWidget();
});
